import React from 'react'
import Main from '../HomeComponent/Main'
import Main2 from '../HomeComponent/Main2'
import { Hero } from '../HomeComponent/Hero'
import { MainFour } from '../HomeComponent/MainFour'
import { MainFive } from '../HomeComponent/MainFive'
import { Card2 } from '../Testimonials/Card2'

export const HomePage = () => {
  
  return (
    <>
    <Hero/>
    <MainFour/>
    <MainFive/>
        <Main />
        <Main2 />
        <Card2/>
    </>
  )
}